import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AxiosError } from 'axios';

import { ServerError } from 'app/shared/interfaces/ServerError.interface';

import { TravelQuotationActions } from 'app/store/data/travelQuotation';
import {
  FormsEnum,
  QuotationStatusEnum,
  StatusCodeEnum,
} from 'app/shared/enums';
import { onSubmitTravelForm } from 'app/store/thunks/onSubmitTravelForm';
import {
  TravelQuotationResultActions,
  selectIsCalculationTriggeredByUser,
} from 'app/store/data/travelQuotationResults';
import { UserActions } from 'app/store/data/user';
import { reportMessage } from 'app/services/errorReporter.service';

const formName = FormsEnum.TravelForm;

export function useTravelForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const isCalculationTriggeredByUser = useSelector(
    selectIsCalculationTriggeredByUser
  );

  const setQuotationStep = (step: number) => {
    dispatch(UserActions.markQuotationStep(step));
  };

  const onSubmitSuccess = () => {
    dispatch(TravelQuotationResultActions.setCalculationTriggeredByUser(true));
  };

  const onSubmitFail = (error: AxiosError<ServerError>) => {
    setIsSubmitting(false);

    if (
      error?.response?.status === StatusCodeEnum.BadRequest &&
      error?.response?.data.details !== undefined
    ) {
      reportMessage(`Unexpected results error reloaded, ${error}`);
      window.location.reload();
    } else {
      reportMessage(`Unexpected results error not reloaded, ${error}`);
    }
  };

  const submit = () => {
    setIsSubmitting(true);
    setQuotationStep(3);
    dispatch(onSubmitTravelForm(onSubmitSuccess, onSubmitFail));
  };

  const goToResults = () => {
    if (!isCalculationTriggeredByUser) {
      return;
    }

    dispatch(
      TravelQuotationActions.setQuotationStatus(
        QuotationStatusEnum.SentToCalculation
      )
    );
  };

  useEffect(goToResults, [isCalculationTriggeredByUser, dispatch]);

  return {
    formName,
    isSubmitting,
    submit,
  };
}
